// import i18n from '@/plugins/i18n'
import { api } from '@/util/api'

export const getForexBaseList = [
  { label: 'AUD', value: 'AUD' },
  { label: 'CNY', value: 'CNY' },
]

// 查詢交易對
export const getForexList = async ({base = 'AUD', quote = ''} = {}) => {
  try {
    const { data } = await api.get(`pair/forex/query?base=${base}&quote=${quote}`)
    return data.data.map(item => {
      return {
        label: item.quote,
        value: item.quote
      }
    })
  } catch (err) {
    console.log('error', err)
  }
}
